import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Importa Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap/js/dist/dropdown.js"

// Importa il tuo CSS personalizzato
import './css/styles.css';


// Service Worker Registration
// Set this to false to disable service worker during development
const ENABLE_SERVICE_WORKER = true;


if (ENABLE_SERVICE_WORKER && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        // console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(err => {
        // console.log('ServiceWorker registration failed: ', err);
      });
  });
} else if ('serviceWorker' in navigator) {
  // Unregister any existing service workers during development
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      // console.log('ServiceWorker unregistered for development');
      
      // Clear all caches
      if (window.caches) {
        caches.keys().then(function(names) {
          for (let name of names) {
            caches.delete(name);
            // console.log('Cache deleted:', name);
          }
        });
      }
    }
  });
}



// Crea un root e rendi l'app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);